import React from "react";
import { FormControlLabel, Checkbox, Radio } from "@mui/material";
import { convertToCamelCaseFromUnderScore } from "../../utils";

const CustomCheckBox = ({ label, type, checked, onChange }) => {
  return (
    <FormControlLabel
      control={
        type === "RADIO" ? (
          <Radio checked={checked} onChange={onChange} />
        ) : (
          <Checkbox checked={checked} onChange={onChange} />
        )
      }
      label={convertToCamelCaseFromUnderScore(label)}
    />
  );
};

export default CustomCheckBox;
